import { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { FiArrowLeft, FiLoader } from 'react-icons/fi'
import axios from 'axios'
import toast from 'react-hot-toast'
import CardGenerator from '../../components/websites/CardGenerator'

export default function CardGeneratorPage() {
  const { websiteId } = useParams()
  const navigate = useNavigate()
  const [website, setWebsite] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadWebsite()
  }, [websiteId])

  const loadWebsite = async () => {
    try {
      const response = await axios.get(`/websites/${websiteId}`)
      if (response.data.success) {
        setWebsite(response.data.website)
      } else {
        toast.error('Website not found')
        navigate('/user-admin/websites')
      }
    } catch (error) {
      console.error('Failed to load website:', error)
      toast.error('Failed to load website')
      navigate('/user-admin/websites')
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <FiLoader className="w-8 h-8 animate-spin mx-auto mb-4 text-blue-600" />
          <p className="text-gray-600">Loading card generator...</p>
        </div>
      </div>
    )
  }

  if (!website) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <p className="text-gray-600 mb-4">Website not found</p>
          <button
            onClick={() => navigate('/user-admin/websites')}
            className="btn-primary"
          >
            Back to Website Builder
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-4">
              <button
                onClick={() => navigate('/user-admin/websites')}
                className="p-2 hover:bg-gray-100 rounded-lg"
                title="Back to Website Builder Dashboard"
              >
                <FiArrowLeft className="w-5 h-5" />
              </button>
              <div>
                <h1 className="text-xl font-semibold text-gray-900">Card Generator</h1>
                <p className="text-sm text-gray-600">{website.name}</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <span className={`px-2 py-1 text-xs rounded-full ${
                website.status === 'published'
                  ? 'bg-green-100 text-green-800'
                  : 'bg-yellow-100 text-yellow-800'
              }`}>
                {website.status}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <CardGenerator website={website} />
      </div>
    </div>
  )
}